<template>
    <SelectorWrap
        :popup="popup"
        :disabled="section.disabled"
        style="width: 100%"
        ref="selectorWrap"
    >
        <template v-slot:selector>
            <div
                class="section-selector"
                :class="{
                    '-disabled': section.disabled || disabled
                }"
                ref="section"
            >
                <div
                    class="selector-container"
                    ref="container"
                    v-if="display"
                    :class="{ '-disabled': disabled }"
                >
                    <Emoji
                        class="input-icon"
                        v-if="display && display.icon"
                        :value="display.icon"
                    />
                    {{ $t(display.display) }}
                </div>
            </div>
        </template>
        <template v-slot:body>
            <div ref="body" class="selector-body">
                <ListPlaceholder
                    v-if="options.length == 0"
                    :title="$t('LABEL_LIST_IS_EMPTY')"
                ></ListPlaceholder>
                <div
                    class="body-row"
                    v-for="(option, index) in filteredOptions"
                    :key="index"
                    @click="selectOption(option)"
                >
                    <div class="row-display">
                        <Emoji
                            class="input-icon"
                            v-if="option && option.icon"
                            :value="option.icon"
                        />
                        {{ $t(option.display) }}
                    </div>
                </div>
            </div>
        </template>
    </SelectorWrap>
</template>
<script>
export default {
    props: {
        value: [Number, String, Boolean],
        options: Array,
        placeholder: String,
        loading: Boolean,
        disabled: Boolean,
        popup: Boolean,
        section: Object
    },
    data() {
        return {
            placeholderLoading: true,
            bodyY: '',
            bodyWidth: ''
        }
    },
    computed: {
        filteredOptions() {
            return this.options.filter(o => !o.hidden)
        },
        display() {
            if (
                ((!this.value || this.value == -1) &&
                    this.value !== 0 &&
                    this.value !== false) ||
                this.options.length == 0
            ) {
                return { display: this.$t('LABEL_EMPTY_COMMENT') }
            }
            if (
                this.options[
                    this.options.findIndex(option => option.value == this.value)
                ]
            ) {
                return this.options[
                    this.options.findIndex(option => option.value == this.value)
                ]
            }
        }
    },
    methods: {
        selectOption(option) {
            this.$emit('input', option.value)
            this.$refs.selectorWrap.toggleBody({ type: 'click' })
        }
    }
}
</script>
<style lang="scss" scoped>
.selector-body {
    max-height: 30vh;
    position: relative;
}
.body-row {
    cursor: pointer;
    &:hover {
        background: darken($background, 2%);
    }
}
.row-display {
    margin-right: 1rem;
}
.display-element {
    margin-right: 1rem;
    display: flex;
    align-items: center;
    transition: $ease;
}
</style>
